/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetUserAccountsResponse,
  SetDefaultAccountRequest,
  SelectAccountResponse,
  SelectAccountRequest,
  GetUserAccountsForAppResponse,
  GetUserAccountOverviewForAppResponse,
  GetUserAccountTransactionsForAppResponse,
  GetUserAccountAssetsForAppResponse,
  GetUserCreditAccountOverviewForAppResponse,
  GetUserCreditCardOverviewForAppResponse,
  GetUserCreditAccountTransactionsForAppResponse,
  UtxUsersAccountGetUserCreditAccountTransactionsForUtxAppParams
} from './schema'



/**
 * Get user accounts
 */
export const utxUsersAccountGetUserAccounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserAccountsResponse>> => {
    return axios.get(
      `/user/accounts`,options
    );
  }


export const getUtxUsersAccountGetUserAccountsQueryKey = () => [`/user/accounts`];

    
export type UtxUsersAccountGetUserAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserAccounts>>>
export type UtxUsersAccountGetUserAccountsQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserAccounts = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserAccounts>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserAccountsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserAccounts>>> = ({ signal }) => utxUsersAccountGetUserAccounts({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * let user set default account
 */
export const utxUsersAccountPostUserDefaultAccount = (
    setDefaultAccountRequest: SetDefaultAccountRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/user/set-default-account`,
      setDefaultAccountRequest,options
    );
  }



    export type UtxUsersAccountPostUserDefaultAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountPostUserDefaultAccount>>>
    export type UtxUsersAccountPostUserDefaultAccountMutationBody = SetDefaultAccountRequest
    export type UtxUsersAccountPostUserDefaultAccountMutationError = AxiosError<unknown>

    export const useUtxUsersAccountPostUserDefaultAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersAccountPostUserDefaultAccount>>, TError,{data: SetDefaultAccountRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersAccountPostUserDefaultAccount>>, {data: SetDefaultAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersAccountPostUserDefaultAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersAccountPostUserDefaultAccount>>, TError, {data: SetDefaultAccountRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Update user selected account and update jwt token
 */
export const utxUsersAccountSelectAccount = (
    selectAccountRequest: SelectAccountRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SelectAccountResponse>> => {
    return axios.post(
      `/users/select-account`,
      selectAccountRequest,options
    );
  }



    export type UtxUsersAccountSelectAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountSelectAccount>>>
    export type UtxUsersAccountSelectAccountMutationBody = SelectAccountRequest
    export type UtxUsersAccountSelectAccountMutationError = AxiosError<unknown>

    export const useUtxUsersAccountSelectAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersAccountSelectAccount>>, TError,{data: SelectAccountRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersAccountSelectAccount>>, {data: SelectAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersAccountSelectAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersAccountSelectAccount>>, TError, {data: SelectAccountRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get user accounts
 */
export const utxUsersAccountGetUserAccountsForUtxApp = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserAccountsForAppResponse>> => {
    return axios.get(
      `/accounts`,options
    );
  }


export const getUtxUsersAccountGetUserAccountsForUtxAppQueryKey = () => [`/accounts`];

    
export type UtxUsersAccountGetUserAccountsForUtxAppQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountsForUtxApp>>>
export type UtxUsersAccountGetUserAccountsForUtxAppQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserAccountsForUtxApp = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserAccountsForUtxApp>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountsForUtxApp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserAccountsForUtxAppQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountsForUtxApp>>> = ({ signal }) => utxUsersAccountGetUserAccountsForUtxApp({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountsForUtxApp>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user account overview
 */
export const utxUsersAccountGetUserAccountOverviewForUtxApp = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserAccountOverviewForAppResponse>> => {
    return axios.get(
      `/accounts/${id}/overview`,options
    );
  }


export const getUtxUsersAccountGetUserAccountOverviewForUtxAppQueryKey = (id: string,) => [`/accounts/${id}/overview`];

    
export type UtxUsersAccountGetUserAccountOverviewForUtxAppQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountOverviewForUtxApp>>>
export type UtxUsersAccountGetUserAccountOverviewForUtxAppQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserAccountOverviewForUtxApp = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserAccountOverviewForUtxApp>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountOverviewForUtxApp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserAccountOverviewForUtxAppQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountOverviewForUtxApp>>> = ({ signal }) => utxUsersAccountGetUserAccountOverviewForUtxApp(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountOverviewForUtxApp>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user account transactions
 */
export const utxUsersAccountGetUserAccountTransactionsForUtxApp = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserAccountTransactionsForAppResponse>> => {
    return axios.get(
      `/accounts/${id}/transaction-history`,options
    );
  }


export const getUtxUsersAccountGetUserAccountTransactionsForUtxAppQueryKey = (id: string,) => [`/accounts/${id}/transaction-history`];

    
export type UtxUsersAccountGetUserAccountTransactionsForUtxAppQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountTransactionsForUtxApp>>>
export type UtxUsersAccountGetUserAccountTransactionsForUtxAppQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserAccountTransactionsForUtxApp = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserAccountTransactionsForUtxApp>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountTransactionsForUtxApp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserAccountTransactionsForUtxAppQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountTransactionsForUtxApp>>> = ({ signal }) => utxUsersAccountGetUserAccountTransactionsForUtxApp(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountTransactionsForUtxApp>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user account assets
 */
export const utxUsersAccountGetUserAccountAssetsForUtxApp = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserAccountAssetsForAppResponse>> => {
    return axios.get(
      `/accounts/${id}/assets`,options
    );
  }


export const getUtxUsersAccountGetUserAccountAssetsForUtxAppQueryKey = (id: string,) => [`/accounts/${id}/assets`];

    
export type UtxUsersAccountGetUserAccountAssetsForUtxAppQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountAssetsForUtxApp>>>
export type UtxUsersAccountGetUserAccountAssetsForUtxAppQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserAccountAssetsForUtxApp = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserAccountAssetsForUtxApp>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountAssetsForUtxApp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserAccountAssetsForUtxAppQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountAssetsForUtxApp>>> = ({ signal }) => utxUsersAccountGetUserAccountAssetsForUtxApp(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserAccountAssetsForUtxApp>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user credit account overview
 */
export const utxUsersAccountGetUserCreditAccountOverviewForUtxApp = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserCreditAccountOverviewForAppResponse>> => {
    return axios.get(
      `/credit-accounts/${id}/overview`,options
    );
  }


export const getUtxUsersAccountGetUserCreditAccountOverviewForUtxAppQueryKey = (id: string,) => [`/credit-accounts/${id}/overview`];

    
export type UtxUsersAccountGetUserCreditAccountOverviewForUtxAppQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountOverviewForUtxApp>>>
export type UtxUsersAccountGetUserCreditAccountOverviewForUtxAppQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserCreditAccountOverviewForUtxApp = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountOverviewForUtxApp>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountOverviewForUtxApp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserCreditAccountOverviewForUtxAppQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountOverviewForUtxApp>>> = ({ signal }) => utxUsersAccountGetUserCreditAccountOverviewForUtxApp(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountOverviewForUtxApp>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user credit card overview
 */
export const utxUsersAccountGetUserCreditCardOverviewForUtxApp = (
    id: string,
    cardId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserCreditCardOverviewForAppResponse>> => {
    return axios.get(
      `/credit-account/${id}/card/${cardId}/overview`,options
    );
  }


export const getUtxUsersAccountGetUserCreditCardOverviewForUtxAppQueryKey = (id: string,
    cardId: string,) => [`/credit-account/${id}/card/${cardId}/overview`];

    
export type UtxUsersAccountGetUserCreditCardOverviewForUtxAppQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditCardOverviewForUtxApp>>>
export type UtxUsersAccountGetUserCreditCardOverviewForUtxAppQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserCreditCardOverviewForUtxApp = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserCreditCardOverviewForUtxApp>>, TError = AxiosError<unknown>>(
 id: string,
    cardId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditCardOverviewForUtxApp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserCreditCardOverviewForUtxAppQueryKey(id,cardId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditCardOverviewForUtxApp>>> = ({ signal }) => utxUsersAccountGetUserCreditCardOverviewForUtxApp(id,cardId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditCardOverviewForUtxApp>>, TError, TData>(queryKey, queryFn, {enabled: !!(id && cardId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user credit account transactions
 */
export const utxUsersAccountGetUserCreditAccountTransactionsForUtxApp = (
    id: string,
    params: UtxUsersAccountGetUserCreditAccountTransactionsForUtxAppParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserCreditAccountTransactionsForAppResponse>> => {
    return axios.get(
      `/GET /credit-account/${id}/transaction-history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxUsersAccountGetUserCreditAccountTransactionsForUtxAppQueryKey = (id: string,
    params: UtxUsersAccountGetUserCreditAccountTransactionsForUtxAppParams,) => [`/GET /credit-account/${id}/transaction-history`, ...(params ? [params]: [])];

    
export type UtxUsersAccountGetUserCreditAccountTransactionsForUtxAppQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountTransactionsForUtxApp>>>
export type UtxUsersAccountGetUserCreditAccountTransactionsForUtxAppQueryError = AxiosError<unknown>

export const useUtxUsersAccountGetUserCreditAccountTransactionsForUtxApp = <TData = Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountTransactionsForUtxApp>>, TError = AxiosError<unknown>>(
 id: string,
    params: UtxUsersAccountGetUserCreditAccountTransactionsForUtxAppParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountTransactionsForUtxApp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersAccountGetUserCreditAccountTransactionsForUtxAppQueryKey(id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountTransactionsForUtxApp>>> = ({ signal }) => utxUsersAccountGetUserCreditAccountTransactionsForUtxApp(id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersAccountGetUserCreditAccountTransactionsForUtxApp>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

